import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Collapsible FAQ list for /peptides/:slug — renders AEO-friendly Q&A the
 * page-level FAQPage JSON-LD points to. Kept as its own component so it can
 * be reused on pillar/business pages without duplicating the accordion state.
 */
export const PeptideFAQ = ({ faqs }) => {
  const [openFaq, setOpenFaq] = useState(null);
  if (!faqs || faqs.length === 0) return null;
  return (
    <section className="py-12 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-[#3a2a26] mb-8">Frequently Asked Questions</h2>
        <div className="space-y-3" data-testid="peptide-faq">
          {faqs.map((faq) => (
            <div
              key={faq.q}
              className="bg-[#fffaf5] border border-[#f0d8d4] rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenFaq(openFaq === faq.q ? null : faq.q)}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <span className="text-[#3a2a26] font-medium pr-4">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-[#b89a6d] flex-shrink-0 transition-transform ${openFaq === faq.q ? "rotate-180" : ""}`} />
              </button>
              {openFaq === faq.q && (
                <div className="px-5 pb-5 text-[#7a6b62] text-sm leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PeptideFAQ;
